<div class="">
  @if (label) {
    <label class="block text-gray-700 text-sm font-bold mb-2">
      {{ label }}
      @if (required) {
        <span class="text-red-500">*</span>
      }
    </label>
  }

  <div>
    <!-- Container for button and dropdown -->
    <div class="relative">
      <!-- Main select button -->
      <button
        type="button"
        [class]="'relative w-full border rounded-md shadow-sm pl-3 pr-10 py-2 text-left focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm h-' + height + (control?.invalid && control?.touched ? ' border-red-500' : ' border-gray-300') + (control?.disabled ? ' bg-gray-50 text-gray-500 cursor-not-allowed' : ' bg-white cursor-pointer')"
        (click)="toggleOpen()"
        [disabled]="loading || control?.disabled"
      >
        <span class="block truncate">{{ getDisplayText() }}</span>

        <!-- Clear button for selections (single or multiple) -->
        @if (hasSelectedOptions() && clearable && !control?.disabled) {
          <div class="absolute inset-y-0 right-8 flex items-center pr-2">
            <button
              type="button"
              class="text-gray-400 hover:text-gray-600"
              (click)="clearAll(); $event.stopPropagation()"
            >
              <lucide-icon [name]="XCircleIcon" class="w-4 h-4"></lucide-icon>
            </button>
          </div>
        }

        <!-- Dropdown arrow -->
        <div class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <lucide-icon
            [name]="ChevronDownIcon"
            class="w-5 h-5 text-gray-400"
            [class.animate-spin]="loading"
          ></lucide-icon>
        </div>
      </button>

      <!-- Dropdown menu -->
      @if (isOpen) {
        <div class="absolute z-50 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base border border-gray-300 overflow-auto focus:outline-none sm:text-sm">
          @if (searchable) {
            <!-- Search input -->
            <div class="sticky top-0 bg-white border-b border-gray-200 p-2">
              <div class="relative">
                <input
                  type="text"
                  class="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  [placeholder]="searchPlaceholder"
                  [(ngModel)]="searchQuery"
                  (input)="onSearchChange()"
                  autocomplete="off"
                >
                <div class="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
                  <lucide-icon
                    [name]="SearchIcon"
                    class="w-4 h-4 text-gray-400"
                  ></lucide-icon>
                </div>
              </div>
            </div>
          }
          @if (allowCreate) {
            <div (click)="$event.stopPropagation();"
                 class="hover:bg-brand-100 w-full cursor-pointer rounded-t border-b border-gray-200 dark:border-gray-800 p-2 flex items-center gap-2">
              <input type="text" [(ngModel)]="newOption" placeholder="Enter new value"
                     [placeholder]="createPlaceholder"
                     class="block w-full text-sm font-medium text-gray-700 dark:text-gray-400 p-2 rounded border border-gray-300 dark:border-gray-700">
              <app-button [label]="'Add'" [disabled]="!newOption || creating" [style]="'primary'" (click)="createOption()"></app-button>
            </div>
          }
          <!-- Loading state -->
          @if (loading) {
            <div class="px-3 py-2 text-sm text-gray-500 text-center">
              Loading...
            </div>
          }

          <!-- No results -->
          @if (!loading && options.length === 0) {
            <div class="px-3 py-2 text-sm text-gray-500 text-center">
              No options found
            </div>
          }

          <!-- Options list -->
          @if (!loading) {
            <div>
              @for (option of options; track option.id) {
                <button
                  type="button"
                  class="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 focus:bg-gray-100 focus:outline-none flex items-center justify-between group cursor-pointer"
                  [class.bg-blue-50]="option.selected"
                  [class.text-blue-600]="option.selected"
                  (mousedown)="select(option.id); $event.preventDefault(); $event.stopPropagation()"
                >
                  <span class="block flex-1" [ngClass]="allowWrap ? 'whitespace-normal' : 'truncate'">{{ option.label }}</span>
                  
                  <!-- Selected checkmark -->
                  @if (option.selected) {
                    <lucide-icon [name]="CheckIcon" class="text-blue-600 ml-2" [size]="16"></lucide-icon>
                  }
                </button>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Selected items display for multiple selection -->
    @if (multiple && hasSelectedOptions() && showSelectedTags) {
      <div class="mt-2">
        <div class="flex flex-wrap gap-1">
          @for (option of selectedOptions(); track option.id) {
            <span class="inline-flex items-center rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              <span class="px-2 py-1">{{ option.label }}</span>
              
              <!-- Remove button -->
              @if (!control?.disabled) {
                <button
                  type="button"
                  class="px-2 py-1 text-blue-600 hover:text-blue-800 hover:bg-blue-200 rounded-r-full transition-colors duration-200"
                  (click)="deselect(option.id)"
                  title="Remove"
                >
                  <lucide-icon [name]="XIcon" class="w-3 h-3"></lucide-icon>
                </button>
              }
            </span>
          }
        </div>
      </div>
    }
  </div>

  <!-- Error message -->
  @if (control?.invalid && control?.touched) {
    <div class="text-red-500 text-xs mt-1">
      @for (errorKey of getErrorKeys(); track errorKey) {
        <div>{{ errorKey | errorMessage:getErrorValue(errorKey) }}</div>
      }
    </div>
  }
</div>
